import {httpRequest} from "../../..//utils/HttpRequest";
import {IPage} from "../../../types/FmsTypes";
import { ShareShop, ShareUser } from "../customer/customerTypes";
import {ISupplierSearch,ISupplierParams,ISupplierDetail,ISupplierInsert,ISupplierUpdata,ISupplierDisable} from "./supplierTypes"
class SupplierService {
    async page(params:ISupplierSearch){
        const apiUrl = "/md/supplier/page"
        return await httpRequest.post<IPage<ISupplierDetail>>(apiUrl,params)
    }
    async insert(params:ISupplierInsert){
        const apiUrl = "/md/supplier/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:ISupplierUpdata){
        const apiUrl = "/md/supplier/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:ISupplierDisable){
        const apiUrl = "/md/supplier/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async shareShop(params:ShareShop){ //共享门店
        const apiUrl = "/md/supplier/shareShop"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async shareUser(params:ShareUser){ //共享门店
        const apiUrl = "/md/supplier/shareUser"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
}
const supplierService = new SupplierService()
export {
    supplierService
}